import Vue from 'vue'
import VueCordova from 'vue-cordova'

const VC = {
    install (Vue, options = null) {
        Vue.use(VueCordova)
        Vue.prototype.$cordova = Vue.cordova
    }
}
  
export default VC


// WEBPACK FOOTER //
// ./src/plugins/cordova.js